module.exports = __webpack_public_path__ + "img/user.a3f5b793.svg";